import { render, staticRenderFns } from "./smallManage.vue?vue&type=template&id=13abbea6&scoped=true&"
import script from "./smallManage.vue?vue&type=script&lang=js&"
export * from "./smallManage.vue?vue&type=script&lang=js&"
import style0 from "./smallManage.vue?vue&type=style&index=0&id=13abbea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13abbea6",
  null
  
)

export default component.exports